<script lang="ts" setup>
import { WheelGesturesPlugin } from 'embla-carousel-wheel-gestures'
import emblaCarouselVue from 'embla-carousel-vue'
const [emblaRef, emblaApi] = emblaCarouselVue({ align: 'start' }, [WheelGesturesPlugin()])

type Media = {
  id: string
  url: string
}

type SpecieCard = {
  id: string
  title: string
  acceptedVernacularName: string
  scientificName: string
  observationAt: string
  medias?: Media[]
  observers: Record<string, unknown>
}

const _props = defineProps<{ items: SpecieCard[] }>()

const activeIndex = ref(0)

const state = ref({
  canScrollPrev: false,
  canScrollNext: true,
})

onMounted(() => {
  if (emblaApi.value) {
    const togglePrevNextBtnsState = () => {
      state.value.canScrollPrev = emblaApi.value?.canScrollPrev() || false
      state.value.canScrollNext = emblaApi.value?.canScrollNext() || false
      activeIndex.value = emblaApi.value?.selectedScrollSnap() || 0 // Update activeIndex
    }

    emblaApi.value
      .on('select', togglePrevNextBtnsState)
      .on('init', togglePrevNextBtnsState)
      .on('reInit', togglePrevNextBtnsState)
  }
})

</script>

<template>
  <div class="social-media-events-carousel w-full">
    <div class="px-bleed mb-6 flex justify-end gap-(--grid-gap)">
      <button
        class="cursor-pointer"
        :class="{ 'opacity-30': !state.canScrollPrev }"
        :disabled="!state.canScrollPrev"
        aria-label="Previous slide"
        @click="() => emblaApi?.scrollPrev()"
      >
        <IconsArrowLeft class="size-5" />
      </button>

      <button
        class="cursor-pointer"
        :class="{ 'opacity-30': !state.canScrollNext }"
        :disabled="!state.canScrollNext"
        aria-label="Next slide"
        @click="() => emblaApi?.scrollNext()"
      >
        <IconsArrowRight class="size-5" />
      </button>
    </div>
    <div ref="emblaRef" class="embla documents pl-bleed pr-bleed">
      <div class="embla__container">
        <div v-for="(card, index) in items" :key="index" class="embla__slide">
          <CardsSpeciesLive :item="card" />
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.embla {
  overflow: hidden;
}
.embla__container {
  display: flex;
  gap: var(--grid-gap);
}

.embla__slide {
  flex: 0 0 85vw;
  min-width: 0;
  
  @media (min-width: 900px) {
    flex: 0 0 var(--cols-4);
  }
}
</style>
